import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';

import { usePageMeta } from '@/hooks/usePageMeta';

import { useLocation } from 'react-router';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

type Props = {
  children: ReactNode;
  pageTitle?: string;
  pageDescription?: string;
};

const MainLayout = ({ children, pageTitle, pageDescription }: Props) => {
  const { pathname } = useLocation();
  usePageMeta(pageTitle, pageDescription, pathname);

  // ページ切り替え時に表示位置をページトップにする
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <>
      <div className=" min-h-screen flex flex-col bg-background text-foreground">
        <Header />

        <main className="flex-grow w-full px-4 pt-4 pb-8 mx-auto max-w-screen-lg">{children}</main>

        <Footer />
      </div>
    </>
  );
};

export default MainLayout;
